export default __webpack_public_path__ + "static/agent-accounts-6dafbf5f23b57dd96273f5d3bbe7887a.png";